import { ClientErrorCodes } from '@logicalcommander/types'
import { RootState } from '../redux/store'

export interface TrialExpiredInput {
  isTrial?: boolean
  expirationDate?: string
  clientErrorCode?: ClientErrorCodes
}

/**
 * Pure check used by the trial lock overlay, guard, banner, and onboarding.
 * Expired when login returned TRIAL_EXPIRED_ERROR, or the company is a trial
 * whose expirationDate is in the past.
 */
export const isTrialExpired = ({ isTrial, expirationDate, clientErrorCode }: TrialExpiredInput): boolean => {
  if (clientErrorCode === ClientErrorCodes.TRIAL_EXPIRED_ERROR) {
    return true
  }

  if (!isTrial || !expirationDate) {
    return false
  }

  return new Date(expirationDate).getTime() <= Date.now()
}

/** Redux selector — single source of truth for "trial period ended". */
export const selectIsTrialExpired = (state: RootState): boolean => {
  const { isTrial, expirationDate } = state.extendedCompanyReducer
  const { clientErrorCode } = state.generalReducer
  return isTrialExpired({ isTrial, expirationDate, clientErrorCode })
}
